var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTalkBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 500 500",
    height: 512,
    viewBox: "0 0 500 500",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m262 500h-250c-6.6 0-12-5.4-12-12v-250c0-130.9 107.1-238 238-238 144.1 0 262 117.9 262 262 0 130.9-107.1 238-238 238z",
    fill: "#45c9a5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m345.588 212.227h-228.991c-11.046 0-20-8.954-20-20s8.954-20 20-20h228.991c11.046 0 20 8.954 20 20s-8.954 20-20 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.991 316.219h-112.394c-11.046 0-20-8.954-20-20s8.954-20 20-20h112.395c11.046 0 20 8.954 20 20s-8.955 20-20.001 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTalkBubble);
export default __webpack_public_path__ + "static/media/green-talk-bubble.465c85dcc61033256ffb0bde9fdf2b03.svg";
export { ForwardRef as ReactComponent };